<div class="qloc-icon {{class}}">
    <div class="qloc-icon-icon">
        <fa-icon *ngIf="image == ''" [icon]="fa" style="color: {{color}}"></fa-icon>
        <img src="{{image}}">
    </div>
    <span>
        <ng-content></ng-content>
    </span>
</div>